import React from 'react'
import PageLayout from './PageLayout'

const PrivacyPolicy = () => {
  return (
    <PageLayout>
      <div className="bg-white p-4 shadow-sm rounded">

        <h3>Privacy Policy</h3>
        <p className="text-muted">Last updated: {new Date().toDateString()}</p>
        <hr />

        <h5>1. Introduction</h5>
        <p>
          Talent Club is committed to protecting your privacy. This Privacy Policy explains
          how we collect, use, disclose, and safeguard your information when you use our platform.
        </p>

        <h5>2. Information We Collect</h5>
        <ul>
          <li>Personal Information: Name, email, mobile number</li>
          <li>Account Data: Login credentials and profile details</li>
          <li>Usage Data: Pages visited, actions performed</li>
          <li>Device Info: IP address, browser, OS</li>
        </ul>

        <h5>3. How We Use Information</h5>
        <ul>
          <li>Provide and maintain services</li>
          <li>Improve platform performance</li>
          <li>Send updates and notifications</li>
          <li>Ensure security and prevent fraud</li>
        </ul>

        <h5>4. Data Sharing</h5>
        <p>
          We do not sell your data. We may share limited data with trusted services
          for analytics, hosting, or legal compliance.
        </p>

        <h5>5. Data Security</h5>
        <p>
          We use encryption, secure servers, and best practices to protect your data.
        </p>

        <h5>6. Cookies Usage</h5>
        <p>
          Cookies help us remember preferences and improve performance.
        </p>

        <h5>7. Your Rights</h5>
        <ul>
          <li>Access your data</li>
          <li>Request deletion</li>
          <li>Update your information</li>
        </ul>

        <h5>8. Data Retention</h5>
        <p>
          We retain your data only as long as necessary for service and legal purposes.
        </p>

        <h5>9. Changes</h5>
        <p>
          We may update this policy anytime. Changes will be reflected here.
        </p>

        <h5>10. Contact</h5>
        <p>Email: support@thetalentclub.co.in</p>

      </div>
    </PageLayout>
  )
}

export default PrivacyPolicy